<template>
  <b-container fluid>
    <b-row align-h="center">
      <b-col cols="12" sm="8" lg="5">

        <div class="div-section-header">
          <b-row>
            <b-col cols="12">
              <div>
                <span class="txt-section-title">Support</span>
              </div>
            </b-col>
          </b-row>
        </div>

        <transition name="fade" mode="out-in">
          <b-alert v-if="error" key="error-box" show variant="danger" class="mt-2">
            {{errorMsg}}
          </b-alert>
          <b-alert v-if="success" key="success-box" show variant="info" class="mt-2">
            Message received.
            <div class="mt-2 text-center">
              <b-button to="/home">Home</b-button>
            </div>
          </b-alert>
        </transition>

        <b-overlay :show="busy">
          <div class="div-section-body">
            <b-form @submit.stop.prevent="submit">
              <b-row>
                <b-col cols="12">
                  <div class="px-2">

                    <!-- Name -->
                    <b-form-group label="Name" label-for="name" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-form-input
                          id="name"
                          v-model="$v.form.name.$model"
                          type="text"
                          placeholder="Your name"
                          :state="validateState('name')"
                          aria-describedby="support-name-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback id="support-name-feedback">Name is a required field and must be at least 3 characters.</b-form-invalid-feedback>
                    </b-form-group>

                    <!-- Office -->
                    <b-form-group label="Office/Company" label-for="office" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-form-input
                          id="office"
                          v-model="$v.form.office.$model"
                          type="text"
                          placeholder="Your office/company"
                          :state="validateState('office')"
                          aria-describedby="support-office-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback id="support-office-feedback">This is a required field and must be at least 3 characters.</b-form-invalid-feedback>
                    </b-form-group>

                    <!-- Email -->
                    <b-form-group label="Email" label-for="email" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                          <b-icon icon="envelope"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input
                          id="email"
                          v-model="$v.form.email.$model"
                          type="email"
                          placeholder="Your email address"
                          :state="validateState('email')"
                          aria-describedby="support-email-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="support-email-feedback">Email address is required.</b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>

                    <!-- Phone -->
                    <b-form-group label="Phone" label-for="phone" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                          <b-icon icon="phone"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input
                          id="phone"
                          v-model="$v.form.phone.$model"
                          type="tel"
                          placeholder="Your phone number"
                          :state="validateState('phone')"
                          aria-describedby="support-phone-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="support-phone-feedback">Phone number is required.</b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>

                    <b-form-group label="Support Topic" label-for="subject" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-form-select id="subject" placeholder="inquiry" v-model="$v.form.subject.$model" :options="options" :state="validateState('subject')" aria-describedby="support-subject-feedback"></b-form-select>
                      <b-form-invalid-feedback id="support-subject-feedback">Select reason for support.</b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Comments" label-for="comment" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                      <b-form-textarea
                        id="textarea"
                        v-model="$v.form.comment.$model"
                        placeholder="Your comments..."
                        :state="validateState('comment')"
                        rows="3"
                        max-rows="6"
                        aria-describedby="support-comment-feedback"
                      ></b-form-textarea>
                      <b-form-invalid-feedback id="support-comment-feedback">Explain reason for support up to 1000 characters.</b-form-invalid-feedback>
                    </b-form-group>

                    <div class="text-center mb-2">
                      <b-button type="submit" variant="info">Submit Request</b-button>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </b-overlay>

      </b-col>
    </b-row>
  </b-container>
</template>

<script>
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"

import { validationMixin } from 'vuelidate'
import { required, email, minLength, maxLength, between } from 'vuelidate/lib/validators'

// var data = {}   // inlined

export default {
  name: "Support",
  data() {
    return {
      debug: false,
      error: false,
      errorMsg: 'System error - contact tech support.',
      busy: false,
      studentHash: this.$root.getToken() || null,
      form: {
        hash: null,
        name: null,
        office: null,
        email: null,
        phone: null,
        subject: null,
        comment: null
      },
      options: [utils.initSelectArray()]
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(4)
      },
      office: {
        required,
        minLength: minLength(4)
      },
      email: {
        required,
        email
      },
      phone: {
        required,
        minLength: minLength(10)
      },
      subject: {
        required
      },
      comment: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(1000)
      }
    }
  },
  props: {},
  computed: { },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    goBack() {
      this.$router.go(-1);
    },
    submit(e) {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        console.log(`ERROR!!`)
        return;
      }
      this.error = false
      this.success = false
      // console.log(`u: ${this.form.username}  p: ${this.form.password}`);
      this.busy = true

      service
        .support(this.form)
        .then( res => {
          if (this.debug) console.log(res.data);
          if (res.status) {
            this.success = true
            this.form.subject = ''
            this.form.comment = ''
            this.$v.form.$reset()
          }
          else {
            this.success = false
            this.errorMsg = data.msg || 'Service error.'
            this.error = true
          }
        })
        .finally( () => {
          this.busy = false
          document.getElementById('app').scrollIntoView()  // scroll to top of page.
        })
        .catch(e => {
          console.log(e);
          this.error = true;
        });
    }
  },
  created() {
    this.form.hash = this.studentHash
    this.form.name = this.$root.getStudentName()
    this.form.email = this.$root.getStudentEmail()

    this.options = this.options.concat(utils.prepSelectArray(['General Feedback','Live Webinar Question','Technical Issue', 'Other']))

    this.success = false
    this.busy = false
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Support.vue